import { createFileRoute } from "@tanstack/react-router"
import DesignSystemIconToolbar from "~/pages/design-system/components/IconToolbar"

export const Route = createFileRoute("/_auth/internal/design-system/components/icon-toolbar")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemIconToolbar />
}
